import { VoiceCallId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { stableQueryOptionsRpc } from "util/requests";

export function useVoiceCallTranscriptQuery(voiceCallId: VoiceCallId) {
    const trpcClient = trpc.useTRPC();
    return useQuery({
        ...trpcClient.telecom.getCallTranscript.queryOptions({ voiceCallId }),
        ...stableQueryOptionsRpc(),
        staleTime: query => (query.state.data?.sentences?.length ? 5 * 60 * 1000 : 0),
        refetchOnMount: true,
    });
}
